module.exports = __webpack_public_path__ + "static/media/EAI-01.cfe9b2fd.jpg";